/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { useLocales } from '../../../locales';
import { newConfigsMap } from './config';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { DEFAULT_RANGE } from '../../../components/datePicker/utils';
import PlatformHeatmapList from '../../../components/analytics/heatmapList';
import {
  ANALYTICS_NAVBAR_ACTIONS,
  BEST_TIME_TO_POST_LABEL,
  CAMPAIGN_ANALYTICS_LABEL,
  GROWTH_LABEL,
  OVERVIEW_LABEL,
  POST_PERFORMANCE_LABEL
} from '../../dashboard/config';
import AnalyticsPagesLayout from '../../../components/analyticsPagesLayout';
import {
  getAnalyticsForLocation,
  transferData
} from '../../../redux/slices/analytics/plotsData';
import { getAllDates } from '../../../utils/dateUtils';
import { TIKTOK_BUSINESS_PAGE } from '../../../config/constants';
import { data } from './demoDataDocument';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { ANALYICS_FOR_SOCIAL_MEDIA } from '../../../config/firebase/collections';
import PostPerformance from '@/pages/allAnalytics/sections/postPerformance';
import GrowthTab from '../shared/GrowthTab';
import OverviewTab from '../shared/OverviewTab';
import {
  tiktokFollowersGrowthConfig,
  tiktokPlatformsGrowthConfig,
  tiktokPlatformsGrowthPerDayConfig,
  tiktokPlatformsGrowthPerPostConfig
} from './growthConfig';
import CampaignAnalysis from '@/pages/allAnalytics/sections/campaignAnalytics';

const TikTokBusinessPageAnalyticsPage: React.FC = () => {
  const { isLoading, uuid, demo, platforms_information } = useSelector(
    (state: any) => state.locationDetails
  );
  console.log(platforms_information);
  const { translate: t } = useLocales();
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  const [error, setError] = useState(false);
  const [oldPlotsData, setOldPlotsData] = useState(null);
  const [loadingOld, setLoadingOld] = useState(true);
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);
  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });
  const type = 'social_media_profile';
  const [plotsData, setPlotsData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // ── 1. Demo mode ───────────────────────────────────────────────────────
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      setLoadingOld(false);
      return;
    }

    // ── 2. Guard clauses ───────────────────────────────────────────────────
    if (!dates) return;

    if (
      !isLoading &&
      uuid &&
      Object.keys(platforms_information).includes(TIKTOK_BUSINESS_PAGE)
    ) {
      const tiktokInfo = platforms_information?.[TIKTOK_BUSINESS_PAGE]?.[0];
      if (!uuid || !tiktokInfo?.uuid) return;

      // ── 3. Start loading states ────────────────────────────────────────────
      setLoading(true);
      setLoadingOld(true);
      setError(false);

      const currentUuid = tiktokInfo.uuid;

      // ── 4. Fetch current-range data, then old-range data ───────────────────
      getAnalyticsForLocation(
        ANALYICS_FOR_SOCIAL_MEDIA,
        type,
        currentUuid,
        dates,
        TIKTOK_BUSINESS_PAGE
      )
        .then((res) => {
          setPlotsData(transferData(res, newConfigsMap));
          setLoading(false);

          // --- Build previous (old) date range ------------------------------
          const rangeLen = getAllDates(dates.startDate, dates.endDate).length;
          const oldStart = new Date(dates.startDate);
          oldStart.setDate(oldStart.getDate() - rangeLen);
          const oldEnd = new Date(dates.startDate);
          oldEnd.setDate(oldEnd.getDate() - 1);

          const oldDates = { startDate: oldStart, endDate: oldEnd };

          // --- Fetch old-range data ----------------------------------------
          return getAnalyticsForLocation(
            ANALYICS_FOR_SOCIAL_MEDIA,
            type,
            currentUuid,
            oldDates,
            TIKTOK_BUSINESS_PAGE
          );
        })
        .then((oldRes) => {
          if (oldRes) {
            setOldPlotsData(transferData(oldRes, newConfigsMap));
          }
          setLoadingOld(false);
        })
        .catch((err) => {
          console.log(err, 'fetch error');
          setError(true);
          setLoading(false);
          setLoadingOld(false);
        });
    }
  }, [uuid, dates, isLoading, demo, platforms_information]);

  if (isLoading) return <IsLoadingIndicator />;

  return (
    <Container>
      <AnalyticsPagesLayout
        actions={ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [OVERVIEW_LABEL]: (
            <OverviewTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              loading={loading}
              error={error}
              newConfigsMap={newConfigsMap}
              platform={TIKTOK_BUSINESS_PAGE}
              followersGrowthConfig={tiktokFollowersGrowthConfig}
              platformsGrowthConfig={tiktokPlatformsGrowthConfig}
              dailyGrowthConfig={tiktokPlatformsGrowthPerDayConfig}
              contentGrowthConfig={tiktokPlatformsGrowthPerPostConfig}
            />
          ),
          [BEST_TIME_TO_POST_LABEL]: (
            <div>
              <PlatformHeatmapList platforms={[TIKTOK_BUSINESS_PAGE]} />
            </div>
          ),
          [POST_PERFORMANCE_LABEL]: (
            <PostPerformance platform={TIKTOK_BUSINESS_PAGE} />
          ),
          [GROWTH_LABEL]: (
            <GrowthTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              newConfigsMap={newConfigsMap}
              error={error}
              loading={loading}
              show_data_import_info={false}
              locationslug={locationslug}
            />
          ),
          [CAMPAIGN_ANALYTICS_LABEL]: (
            <CampaignAnalysis platform={TIKTOK_BUSINESS_PAGE} />
          )
        }}
      />
    </Container>
  );
};
export default TikTokBusinessPageAnalyticsPage;
